var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspaceDropdownDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 225,
    height: 1,
    viewBox: "0 0 225 1",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H225",
    stroke: "#FFF1C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceDropdownDivider);
export default __webpack_public_path__ + "static/media/workspaceDropdownDivider.1121aed323658591641d8020de5d2dd8.svg";
export { ForwardRef as ReactComponent };